<template>
	<v-dialog
		v-model="visible"
		class="white"
		fullscreen
		hide-overlay
		transition="dialog-bottom-transition"
		persistent>

		<scoped-overflow-layout :loading="loading">
			<template #toolbar>
				<v-toolbar dense card>
					<img class="ml-3" src="@/assets/logo.png" height="32"/>
					<v-toolbar-title class="hidden-xs-only">{{ $t('DISCLAIMER_TITLE') }}</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-toolbar-items>
						<v-btn flat small color="error" :disabled="loading" @click="decline">{{ $t('DISCLAIMER_DECLINE_TEXT') }}</v-btn>
						<v-btn flat small color="primary" :disabled="loading" @click="accept">{{ $t('DISCLAIMER_ACCEPT_TEXT') }}</v-btn>
					</v-toolbar-items>
				</v-toolbar>
			</template>

			<v-card tile flat>
				<v-card-title class="hidden-sm-and-up title pb-0">{{ $t('DISCLAIMER_TITLE') }}</v-card-title>
				<v-card-text v-html="disclaimer" />
			</v-card>

			<template #footer>
				<v-layout class="secondary pa-3">
					<v-checkbox 
						class="text--white ma-0"
						v-model="checkboxState"
						dark hide-details
						:label="$t('DISCLAIMER_DECLARATION_TEXT')"
						:error="checkboxError"
						@change="validate" />
				</v-layout>
			</template>

		</scoped-overflow-layout>
	</v-dialog>
</template>


<script>
import { mapGetters, mapState } from 'vuex';
import ScopedOverflowLayout from "@/layouts/ScopedOverflowLayout.vue";

export default {
	name: "dialog-disclaimer",
	components: { ScopedOverflowLayout },
	data() { return {
		currentWidth: window.innerWidth,
		checkboxState: false,
		checkboxError: false,
	}},
	computed: {
		...mapState(['disclaimer']),
		...mapState('auth', {
			visible: 'disclaimerDialogVisible',
		}),
		...mapGetters('auth', ['disclaimerAcceptedAt']),
		loading() { return !this.disclaimer },
	},
	methods: {
		accept() {
			if (!this.validate()) { return }
			this.$emit('accept');
		},
		decline() {
			this.$emit('decline');
		},
		validate() {
			this.checkboxError = !this.checkboxState;
			return this.checkboxState;
		},
	},
	mounted() {
		this.$store.dispatch('fetchDisclaimer');
	},
}
</script>
